import { render, staticRenderFns } from "./SpeakerDetails.vue?vue&type=template&id=7a882114&scoped=true"
import script from "./SpeakerDetails.vue?vue&type=script&lang=js"
export * from "./SpeakerDetails.vue?vue&type=script&lang=js"
import style0 from "./SpeakerDetails.vue?vue&type=style&index=0&id=7a882114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a882114",
  null
  
)

export default component.exports